import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import type { SxProps, Theme } from '@mui/material/styles'
import type { MenuItemConfig } from './menu-items'
import ProfileHeader from './ProfileHeader'
import WelcomeBanner from './WelcomeBanner'
import MenuList from './MenuList'
import SignOutRow from './SignOutRow'
import { BLUE, DIVIDER_BLUE } from './constants'

interface AccountCardProps {
    isMobile: boolean
    isFullscreen: boolean
    customerName: string
    profilePicUrl: string
    baId: string
    isProfileLoading: boolean
    banner: { title: string; description: string; buyNowText: string } | null
    menuItems: MenuItemConfig[]
    onLogout: () => void
}

const buildSizingSx = (isMobile: boolean, isFullscreen: boolean): SxProps<Theme> => {
    if (isFullscreen) return { height: '100vh', minHeight: '100vh' }
    if (isMobile) return {}
    return { height: 'fit-content' }
}

const AccountCard = ({ isMobile, isFullscreen, customerName, profilePicUrl, baId, isProfileLoading, banner, menuItems, onLogout }: AccountCardProps) => {
    return (
        <Stack
            sx={{
                width: isMobile ? '100%' : '40%',
                maxWidth: isMobile ? 'none' : 430,
                flex: 'none',
                minWidth: 0,
                bgcolor: BLUE,
                borderRadius: isFullscreen ? 0 : '12px',
                overflow: 'scroll',
                color: '#FFFFFF',
                ...buildSizingSx(isMobile, isFullscreen),
                maxHeight: 'fit-content'
            }}
            data-testid="account-card-stack-profile-header">
            <ProfileHeader
                customerName={customerName}
                profilePicUrl={profilePicUrl}
                baId={baId}
                isLoading={isProfileLoading}
                data-testid="account-card-profile-header"
            />
            {banner && (
                <WelcomeBanner title={banner.title} description={banner.description} buyNowText={banner.buyNowText} data-testid="account-card-welcome-banner" />
            )}
            <MenuList items={menuItems} isMobile={isMobile} data-testid="account-card-menu-list" />
            <Divider sx={{ borderColor: DIVIDER_BLUE, mt: isMobile ? '10px' : '20px' }} data-testid="account-card-divider" />
            <SignOutRow onLogout={onLogout} data-testid="account-card-sign-out-row" />
        </Stack>
    )
}

export default AccountCard
